(function () {
  if (window.KTStickyATCReady) return;
  window.KTStickyATCReady = true;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function clampQty(value) {
    var qty = parseInt(value, 10);
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function initStickyATC(bar) {
    if (bar.dataset.ktStickyReady === 'true') return;
    bar.dataset.ktStickyReady = 'true';

    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;

    var originalForm = section.querySelector('[data-product-form]');
    var originalButton = section.querySelector('[data-product-form] [data-add-to-cart]');
    var originalQty = section.querySelector('[data-quantity-input][name="quantity"]');
    var productJsonNode = section.querySelector('[data-product-json]');
    var stickyButton = bar.querySelector('[data-kt-sticky-submit]');
    var stickyButtonText = bar.querySelector('[data-kt-sticky-submit-text]');
    var stickyQty = bar.querySelector('[data-kt-sticky-qty]');
    var qtyMinus = bar.querySelector('[data-kt-sticky-qty-minus]');
    var qtyPlus = bar.querySelector('[data-kt-sticky-qty-plus]');
    var variantSelect = bar.querySelector('[data-kt-sticky-variant]');
    var stickyPrice = bar.querySelector('[data-kt-sticky-price]');
    var stickyImage = bar.querySelector('[data-kt-sticky-image]');
    var productJson = null;

    if (!originalForm || !originalButton || !stickyButton) return;

    try {
      productJson = productJsonNode ? JSON.parse(productJsonNode.textContent) : null;
    } catch (error) {
      productJson = null;
    }

    function ensureQuantityInput() {
      if (originalQty) return originalQty;

      originalQty = document.createElement('input');
      originalQty.type = 'hidden';
      originalQty.name = 'quantity';
      originalQty.value = stickyQty ? stickyQty.value : '1';
      originalForm.appendChild(originalQty);
      return originalQty;
    }

    function syncQuantityToMain() {
      var qty = stickyQty ? clampQty(stickyQty.value) : 1;
      if (stickyQty) stickyQty.value = qty;

      var input = ensureQuantityInput();
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncQuantityFromMain() {
      if (!stickyQty || !originalQty) return;
      stickyQty.value = clampQty(originalQty.value);
    }

    function getVariantById(id) {
      if (!productJson || !productJson.variants) return null;
      return productJson.variants.find(function (variant) {
        return String(variant.id) === String(id);
      });
    }

    function syncVariantToMain(variantId) {
      var variant = getVariantById(variantId);
      if (!variant || !productJson || !productJson.options) return;

      productJson.options.forEach(function (optionName, index) {
        var optionValue = variant.options[index];
        var inputs = section.querySelectorAll('[name^="options["]');

        inputs.forEach(function (input) {
          var inputName = input.name.replace(/^options\[/, '').replace(/\]$/, '');
          if (inputName !== optionName) return;

          if (input.type === 'radio') {
            if (input.value === optionValue) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            input.value = optionValue;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      var idInput = originalForm.querySelector('[name="id"]');
      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function updatePriceFromMain() {
      var mainPrice = section.querySelector('[data-product-price]');
      if (mainPrice && stickyPrice) {
        stickyPrice.textContent = mainPrice.textContent.trim();
      }
    }

    function updateButtonState() {
      stickyButton.disabled = originalButton.disabled;

      var mainText = originalButton.querySelector('[data-add-to-cart-text]');
      if (mainText && stickyButtonText && !stickyButton.classList.contains('is-loading')) {
        stickyButtonText.textContent = mainText.textContent.trim();
      }
    }

    function updateFromVariant(variant) {
      if (!variant) {
        stickyButton.disabled = true;
        return;
      }

      if (variantSelect) variantSelect.value = variant.id;
      if (stickyButton) stickyButton.disabled = !variant.available || originalButton.disabled;

      if (variant.featured_image && variant.featured_image.src && stickyImage) {
        stickyImage.src = variant.featured_image.src;
      }

      window.setTimeout(function () {
        updatePriceFromMain();
        updateButtonState();
      }, 0);
    }

    function updateVisibility() {
      var rect = originalButton.getBoundingClientRect();
      var shouldShow = rect.bottom < 0;

      bar.hidden = false;
      bar.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('kt-sticky-atc-visible', shouldShow);

      if (shouldShow) {
        document.documentElement.style.setProperty('--kt-sticky-atc-height', bar.offsetHeight + 'px');
      }
    }

    function scheduleVisibilityUpdate() {
      window.requestAnimationFrame(updateVisibility);
    }

    if (stickyQty) stickyQty.addEventListener('change', syncQuantityToMain);
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        stickyQty.value = clampQty(stickyQty.value) - 1;
        stickyQty.value = clampQty(stickyQty.value);
        syncQuantityToMain();
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        stickyQty.value = clampQty(stickyQty.value) + 1;
        syncQuantityToMain();
      });
    }
    if (originalQty) originalQty.addEventListener('change', syncQuantityFromMain);
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        syncVariantToMain(variantSelect.value);
      });
    }

    stickyButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (stickyButton.disabled) return;

      syncQuantityToMain();
      stickyButton.classList.add('is-loading');
      if (stickyButtonText) stickyButtonText.textContent = 'Adding...';

      originalButton.click();

      window.setTimeout(function () {
        stickyButton.classList.remove('is-loading');
        updateButtonState();
      }, 3500);
    });

    document.addEventListener('theme:variant:change', function (event) {
      if (!section.contains(event.target)) return;
      updateFromVariant(event.detail.variant);
    });

    document.addEventListener('theme:cart:change', function () {
      stickyButton.classList.remove('is-loading');
      updateButtonState();
    });

    new MutationObserver(updateButtonState).observe(originalButton, {
      attributes: true,
      childList: true,
      subtree: true
    });

    window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
    window.addEventListener('resize', scheduleVisibilityUpdate);

    syncQuantityFromMain();
    updatePriceFromMain();
    updateButtonState();
    updateVisibility();
  }

  onReady(function () {
    document.querySelectorAll('[data-kt-sticky-atc]').forEach(initStickyATC);
  });
})();
